const initialState = {
    user: null,
    credentials: null,
    status: 'initial',
    errorMessage: null
  };

export default initialState;